module.exports = __webpack_public_path__ + "img/6.6b2b74e1.svg";